module.exports = __webpack_public_path__ + "static/media/flower.bab0dcfd.png";